export default __webpack_public_path__ + "f75698a7fd47e9c18c75fed1cf7afb94.gif";